import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { CardCarHomeComponent } from './card-car-home.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  declarations: [CardCarHomeComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    DirectivesModule,
    MatIconModule,
    MatDividerModule
  ],
  exports: [
    CardCarHomeComponent,
  ],
  providers: [DecimalPipe]
})
export class CardCarHomeModule { }
